import type { StaticSharedField } from './types';
import {
  ERR_TYPE_ENUM_IS_DROPDOWN,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_DROPDOWN,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useMakeUnit(): StaticSharedField {
  return {
    type: FIELD_TYPE_DROPDOWN,
    label: 'Unit of measurement:',
    propName: 'unit_of_measurement',
    element: 'unit_of_measurement',
    defaultValue: 'kg',
    values: [
      { name: 'kg', displayName: 'kgCO₂e/Unit' },
      { name: 'tonne', displayName: 'tCO₂e/Unit' },
    ],
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOUNIT',
        errStr: 'Please select a unit of measurement',
      },
      {
        rule: ERR_TYPE_ENUM_IS_DROPDOWN,
        errCode: 'ERRUNITNOTFOUND',
        errStr: 'Unit of measurement not found',
      },
    ],
  };
}
